export default "__VITE_ASSET__D8oKB_no__"